import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import ErnaehrungAbschluss from '@/components/ErnaehrungAbschluss';

/* E23 (15.10.2026): /ernaehrung/abschluss?lead_id=… — „Neuer Kunde in einem Fluss“. Aufgerufen von /ernaehrung („Neuer Kunde“),
   Ernährung › Mitglied (Karte Zusatz-Abo) und vom Empfang-Hinweis „Ernährung anbieten“ (E13). */
export default function ErnaehrungAbschlussPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const leadId = params.get('lead_id') || null;
  const zurueck = () => navigate(leadId ? `/ernaehrung/${leadId}` : '/ernaehrung');
  return (
    <div className="p-4 md:p-6 max-w-6xl mx-auto space-y-4" data-testid="ernaehrung-abschluss-page">
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="sm" onClick={zurueck}><ArrowLeft className="w-4 h-4 mr-1" />Zurück</Button>
        <h1 className="text-xl font-bold">Neuer Kunde — Ernährungscoaching</h1>
      </div>
      <ErnaehrungAbschluss leadId={leadId} onAbbruch={zurueck} onFertig={() => {}} />
    </div>
  );
}
